module.exports = __webpack_public_path__ + "static/media/kctf.9b8a8a74.png";